import { EligibilityOffer } from '../types/eligibility-offer';
import { AppEventSdk } from '@sxm-de/dev-kits/web-sdk/types';

export function trackOffersPresented(
    appEventSdk: AppEventSdk,
    {
        offers,
        promoCode,
    }: { offers: { offer: EligibilityOffer }[]; promoCode?: string },
) {
    appEventSdk.trackEvent({
        event: 'offers-presented',
        offerInfo: {
            offers: offers.map(({ offer }) => ({
                id: offer.id,
                planCode: offer.name,
                price: offer.phases[0]?.price?.total?.value,
                packageName: offer.products?.[0]?.id,
                retailPrice: offer.basePrice.total.value,
                promoCode: promoCode ?? '',
                phases: offer.phases.map(({ type }) => type),
            })),
        },
    });
}
